<template>
  <div class="flex items-center gap-1 text-label">
    <span
      v-if="callerInfo.from"
      v-tooltipable
      class="max-w-30 shrink-0 truncate"
    >
      {{ callerInfo.from }}
    </span>
    <div
      v-if="callerInfo.to"
      class="flex min-w-0 flex-1 items-center space-x-0-5"
    >
      <span class="shrink-0 whitespace-nowrap">
        {{ $t("ACTIVITY.CONTACTS.REACHED_TO").toLowerCase() }}:
      </span>
      <span v-tooltipable class="min-w-0 truncate">
        {{ callerInfo.to }}
      </span>
    </div>
    <date-time :date="item.created_at" class="shrink-0 whitespace-nowrap" />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import DateTime from "@/components/ui/ConvertibleDateTime.vue";

import type { CallLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: CallLogData;
}>();

const callerInfo = computed(() => {
  const { is_outgoing } = item;
  const { full_name } = item.user ?? {};
  const { name } = item.callee ?? {};
  const from = is_outgoing ? full_name : name;
  const to = is_outgoing ? name : full_name;
  return { from, to };
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";
</style>
